<template>
	<div class="inner-page render-form">

		<AppHead :title="formName" />

		<PageHeader 
			:title="formName"
			desc="Please complete this form"
			:hasButton="false"
			:showHelper="false"
			:backLocation="`/cases/${caseHash}`"
			/>

		<template v-if="hasCompleted || formComplete">
			<Placeholder 
				message="Thank you for completing this form. You may now return to the case."
				>
				<Button 
					label="Back to case"
					color="green"
					icon="chevron-left"
					@click="backToCase"
					/>
			</Placeholder>
		</template>

		<template v-else>

			<template v-if="form.upload">

				<Placeholder 
					:message="form.upload_description ? form.upload_description : 'Please upload the required document.'"
					>

					<UploadBox
						:case="case"
						designation="form-upload"
						@done="uploadingFinished"
						:maxFiles="1"
						>
						<Button 
							label="Save"
							color="green"
							icon="save"
							:disabled="collectedUploadIds.length == 0"
							@click="surveyComplete"
							/>
					</UploadBox>
					
				</Placeholder>

			</template>

			<template v-else>

				<div class="survey-container">
					<div id="survey" />
				</div>

				<div
					class="button-container"
					>
					<Button 
						v-if="!formComplete"
						label="Save progress"
						color="green"
						icon="save"
						@click="saveProgress"
						/>
					<Button 
						v-if="formComplete"
						label="Back to case"
						color="green"
						icon="chevron-left"
						@click="backToCase"
						/>
				</div>

			</template>

		</template>



	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import Placeholder from "@/Components/Placeholder"
import UploadBox from "@/Components/Upload/UploadBox"

import "survey-core/defaultV2.min.css";
import { StylesManager } from "survey-core"
import { Survey } from 'survey-knockout-ui'

StylesManager.applyTheme("defaultV2")

export default {
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Survey,
		Button,
		Placeholder,
		UploadBox
	},
	layout: AppLayout,
	props: {
		form: {
			type: Object,
			required: true
		},
		surveyJson: {
			type: [String, Object],
			required: true,
			default: '{}'
		},
		caseHash: {
			type: String,
			required: true
		},
		week: {
			type: [String, Boolean],
			required: false,
			default: false
		},
		existingResults: {
			type: [Array, Object, Boolean],
			required: false,
			default: false
		},
		hasCompleted: {
			type: Boolean,
			required: false,
			default: false
		},
		case: {
			type: [Object, Boolean],
			required: false,
			default: false
		}
	},
	data: () => {
		return {
			formComplete: false,
			survey: null,
			collectedUploadIds: []
		}
	},
	mounted() {
		console.log('form', this.form)
		// console.log('surveyJson', this.surveyJson)
		// console.log('existingResults', this.existingResults)

		if(!this.hasCompleted){
			
			this.survey = new Survey({
				...this.surveyJson,
				completedHtml: '<h3>Thank you for completing this form.</h3> <p>You may now return to the case.</p>',
			})
			this.survey.render("survey")
			this.survey.onComplete.add(this.surveyComplete)

			if(this.existingResults){
				this.survey.data = this.existingResults.result_data
			}

		}

	},
	methods: {
		uploadingFinished(data){
			this.collectedUploadIds.push(data.upload_id)
		},
		saveProgress(){
			const answers = this.survey.getPlainData()

			// take the array returned and create a new object with the key of each item being 'name' of answers and the value as 'value'
			// this is the format we need to save the answers to the database
			let compatibleAnswersObject = {}
			answers.forEach(answer => {
				if(answer.value){
					compatibleAnswersObject[answer.name] = answer.value
				}
			})

			const payload = {
				answers: compatibleAnswersObject,
				schema: this.surveyJson,
				complete: this.formComplete,
				week: this.week,
				formName: this.form.name,
				existingResult: this.existingResults ? this.existingResults.id : false
			}

			this.saveResults(payload)

		},
		surveyComplete(sender) {

			if(this.form.upload){
				if(this.collectedUploadIds.length == 0){
					return
				}
			}

			this.formComplete = true

			const payload = {
				answers: sender.data ? sender.data : {},
				schema: this.surveyJson,
				complete: this.formComplete,
				week: this.week,
				formName: this.form.name,
				existingResult: this.existingResults ? this.existingResults.id : false
			}

			if(this.form.upload){
				payload.uploadIds = this.collectedUploadIds
			}

			this.saveResults(payload)
			
		},
		saveResults(payload){
			console.log('saveResults', payload)
	
			this.$inertia.post(`/cases/${this.caseHash}/form/${this.form.id}`, payload)
		},
		backToCase() {
			this.$inertia.visit(`/cases/${this.caseHash}`)
		}
	},
	computed: {
		formName(){
			if(this.week != null){
				return `${this.form.name} ${this.week ? ` (Week ${this.week})` : ''}`
			} else {
				return this.form.name
			}
		}
	}
}

</script>

<style lang="sass">

.render-form
	.survey-container
		.sd-root-modern
			background-color: transparent

		.sd-body.sd-body--static
			padding-top: 0
			padding-bottom: 0

		.sd-row__question, .sd-btn
			border-radius: 8px
			box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2)

		.sd-completedpage 
			h3
				font-family: 'Roboto Condensed', sans-serif
				font-size: 28px
				margin-bottom: 20px

			p
				font-size: 18px
				margin-bottom: 20px

	.button-container
		display: flex
		justify-content: center

</style>